import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { Endpoint } from '@philips-emr/hpms-stipulator-commons';
import { FetchAPI, Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import { RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FaturasAliases as Aliases } from '../../codegen';
import BaseController from '../BaseController';

export interface Fatura {
  nrSeqFatura: number;
  dtVencimento: string,
  nmPagador: string,
  nrNotaFiscal: string,
  ieSituacao: FaturaSituacao,
  dsSituacao: string,
  nrTitulo: number,
  vlFatura: number,
}

enum FaturaSituacao {
  DEBITO = 'D',
  PAGO = 'P',
}

export default class BaseFaturaCustomCardController extends BaseController {

  @Inject(Aliases.FETCH_FATURAS)
  protected fetchFatura: FetchAPI;

  protected onMountFetchFaturas(): void {
    const url = Endpoint.GET.FATURAS;
    this.fetchFatura.setEndpoint(url);
  }

  protected onDynamicContentRenderCardLote({ data, render }: RenderEvent): void {
    const { ieSituacao } = data as Fatura;

    render((): ReactElement => getFaturaStamp(ieSituacao));
  }

}

function getFaturaStamp(ieSituacao: FaturaSituacao): ReactElement {
  return (
    <Stamp
      color={getFaturaIconColor(ieSituacao)}
      icon={getFaturaIconType(ieSituacao)}
      label={getFaturaStampLabel(ieSituacao)}
    />
  );
}

function getFaturaStampLabel(ieSituacao: FaturaSituacao): string {
  const labels: Record<string, string> = {
    [FaturaSituacao.DEBITO]: 'stipulator.debito',
    [FaturaSituacao.PAGO]: 'stipulator.pago',
  };
  
  return labels[ieSituacao];
}

function getFaturaIconColor(ieSituacao: FaturaSituacao): Color {
  const color = {
    [FaturaSituacao.DEBITO]: Color.SAFETY_ORANGE,
    [FaturaSituacao.PAGO]: Color.SAFETY_GREEN,
  };

  return color[ieSituacao];
}

function getFaturaIconType(ieSituacao: FaturaSituacao): StampIcon {
  const icon = {
    [FaturaSituacao.DEBITO]: StampIcon.WARNING,
    [FaturaSituacao.PAGO]: StampIcon.CHECK,
  };

  return icon[ieSituacao];
}
